<template>
  <div>
    <!-- Test Task Content -->
    <v-sheet
        v-if="entity.uuid"
        :color="wsLIGHTCARD"
        class="wsRoundedHalf pa-4 mb-5"
    >


      <v-sheet
          v-for="(item,i) in testInfoBoxesItems" :key="i"
          :color="item.color || null"
          class="wsRoundedSemi mb-1 px-4 py-2 d-flex align-center"
      >
        <v-icon :color="item.iconColor || wsATTENTION" class="mr-2">{{ item.icon || 'mdi-cog' }}</v-icon>
        <h5 :style="`color : ${item.fontColor || wsDARKER}`">
          {{ item.text }}
        </h5>
      </v-sheet>


      <ws-button
          v-if="(getStartNewTest || getTestInProcess) && !waitingForManualCheck"
          :to="businessDashLink('courses/test/' + entity.test_id)"
          :label-raw="getTestStartText"
          block
          class="mt-4"
      />

      <v-sheet v-if="entity.student_test && !getTestInProcess" class="wsRoundedSemi mt-5 mb-1 px-4 py-2">

        <ws-data-table
          :items="entity.student_test || []"
          :headers="testTriesHeaders"
          no-header
          disable-pagination
          no-footer
          :row-action="(studentTest) => openStudentTestPreview(studentTest)"
        >

          <template #item.result="{item}">
            <div>

              <h5 v-if="item.status !== 'manual_check'">{{ item.result }}</h5>
            </div>

          </template>
          <template #item.status="{item}">
            <h5 class="text-no-wrap">
             {{ getStatusText(item.status) }}
            </h5>
          </template>

          <template #item.description>
            <h5 class="text-no-wrap">{{ $t('Details') }} <v-icon>mdi-chevron-right</v-icon> </h5>
          </template>

        </ws-data-table>


      </v-sheet>

    </v-sheet>

    <!-- Test Preview Dialog -->
    <test-preview-dialog
        v-if="displayTestResult"
        v-model="displayTestResult"
        :student-test-id="selectedStudentTest"
        is-student
    />

  </div>
</template>

<script>
import testPreviewDialog from "@/components/pages/westudy/tests/testPreviewDialog.vue";

export default {
  name: "videoTaskViewer",
  components: {testPreviewDialog},
  props : {
    entity : {
      type : Object,
      default() { return {} }
    }
  },
  data() {
    return {
      displayTestResult : false,
      selectedStudentTest : null
    }
  },
  computed : {
    testTriesHeaders() {
      return [
        { value : 'time_started' },
        { value : 'result' , width : 5},
        { value : 'status' , width : '5px'},
        { value : 'description' , width : 5 },
      ]
    },
    waitingForManualCheck() {
      if (!this.entity.student_test) {
        return false
      }

      if (!this.entity.student_test.length) {
        return false
      }

      const lastTry = this.entity.student_test[this.entity.student_test.length - 1]

      return lastTry.status === 'manual_check'
    },
    testInfoBoxesItems() {

      if (this.getTestInProcess) {
        return [{
          text : this.$t('TestInProcess'),
          icon : 'mdi-progress-check',
          color : this.wsBACKGROUND,
          iconColor : this.wsACCENT
        }]
      }

      if (this.waitingForManualCheck) {
        return [
          { text : this.$t('testing.waiting_manual_check') ,
            icon : 'mdi-av-timer',
            color : this.wsBACKGROUND,
            iconColor : this.wsACCENT
          }
        ]
      }



      const passingScoreText = `${this.$t('TaskPassPoints')} - ${this.entity.test_pass_score}%`
      const testDurationText = `${this.$t('testing.test_duration')} - ${ this.$tc('_minutes' , this.entity.test_duration)}`
      const testTriesText = `${this.$t('TriesLeft')} - ${ this.entity.test_tries}`



      let items = [
        { text : passingScoreText ,
          icon : 'mdi-text-box-check-outline'
        },
      ]
      let limitItems = [
        { text : testDurationText ,
          icon : 'mdi-av-timer'
        }
      ]

      if (this.getStartNewTest) {
        limitItems.push( { text : testTriesText ,
          icon : 'mdi-sync-alert'
        })
      }

      if ( this.entity.test_unlimited ) {
        items = [...items, ...limitItems]
      }

      if ( this.entity.student_test) {
        const resultText = `${this.$t('WorstResult')} - ${this.getWorstTestResult}% / ${this.$t('BestResult')} - ${this.getBestTestResult}%`

        items = [...items , {
          text : resultText,
          icon : 'mdi-sync-alert'
        }]

        if ((this.entity.test_unlimited && !this.getTestInProcess && !this.getStartNewTest && !this.getSuccess)) {

          return [
            {
              text : this.$t('TestNoMoreTries'),
              color : this.wsWARNING + 33,
              icon : 'mdi-emoticon-sad-outline',
              iconColor : this.wsWARNING,
              fontColor : this.wsWARNING
            },
            {
              text : resultText,
              icon : 'mdi-sync-alert'
            }
          ]
        }
      }

     if (this.getSuccess) {
       items.unshift(
           {
             text : this.$t('testing.test_success'),
             icon : 'mdi-check-circle-outline' ,
             color : this.wsSUCCESS + 44,
             iconColor : this.wsSUCCESS,
             fontColor : this.wsSUCCESSDARK
           }
       )
     }



      return items
    },
    getStartNewTest() {

      if (!this.entity.test_unlimited) { return true }
      if ( this.entity.test_tries < 1 ) { return false }
      return true;
    },
    getSuccess() {
      if ( this.entity.student_test) {
        if (  this.entity.student_test.length > 0 ) {
          let hasSuccess = this.entity.student_test.find(el=> el.status === 'success')
          if ( hasSuccess ) { return true }
        }
      }

      return false
    },
    getTestInProcess() {
      if ( this.entity.student_test ) {
        let inProcess = this.entity.student_test.find(el => el.status === 'in_process')
        if ( inProcess ) {
          return true
        }
      }
      return false
    },
    getTestStartText() {
      if ( this.getTestInProcess ) {
        return this.$t('Proceed')
      }
      return this.$t('StartTest')
    },
    getBestTestResult() {
      if ( !this.entity.student_test ) {
        return null
      }
      let items = this.entity.student_test.map( el => el.result )
      let sorted = items.sort( (a,b) => a - b )

      return sorted[0]
    },
    getWorstTestResult() {
      if ( !this.entity.student_test ) {
        return null
      }
      let items = this.entity.student_test.map( el => el.result )
      let sorted = items.sort( (a,b) => b - a )
      return sorted[0]
    },
    getTries() {
      if ( this.entity.student_test) {
        return this.entity.test_tries - this.entity.student_test.length
      }
      return this.entity.test_tries;
    },
  },
  methods : {
    getStatusText(status) {

      if (status === 'manual_check') {
        return 'Очікує перевірки'
      }

      return status === 'success' ? this.$t('success') : this.$t('failed')
    },

    openStudentTestPreview(item) {
      this.selectedStudentTest = item.uuid
      this.displayTestResult = true
    }
  }
}
</script>

<style scoped>

</style>